import { sponsorByID, sponsorCreate, sponsorDestroy, sponsorUpdate, sponsorsList } from '@/services/agency/showcaseSponsors.service'

export default {
	namespaced: true,
	state: {
		// SHOWCASES SPONSORS
		sponsorsList: {
			data: [],
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		sponsor: {},
		// STATUS SHOWCASES SPONSORS
		sponsorsStatus: 'pending',
		sponsorsSaveStatus: 'init',
		sponsorsDeleteStatus: 'init',
	},
	getters: {
		// SHOWCASES SPONSORS
		getSponsorsList(state) {
			return state.sponsorsList
		},
		getSponsor(state) {
			return state.sponsor
		},
		// SHOWCASES SPONSORS
		getSponsorsDeleteStatus(state) {
			return state.sponsorsDeleteStatus
		},
		getSponsorsSaveStatus(state) {
			return state.sponsorsSaveStatus
		},
		getSponsorsStatus(state) {
			return state.sponsorsStatus
		},
	},
	mutations: {
		// SHOWCASES SPONSORS
		SPONSORS_LIST(state, value) {
			state.sponsorsList = value
		},
		SET_SPONSOR(state, value) {
			state.sponsor = value
		},
		// STATUS SHOWCASES SPONSORS
		SPONSORS_STATUS(state, value) {
			state.sponsorsStatus = value
		},
		SPONSOR_SAVE_STATUS(state, value) {
			state.sponsorsSaveStatus = value
		},
		SPONSOR_DELETE_STATUS(state, value) {
			state.sponsorsDeleteStatus = value
		},
	},
	actions: {
		// SHOWCASES Sponsors
		async fetchSponsorList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('SPONSORS_STATUS', 'pending')
			commit('SPONSORS_LIST', {
				data: [],
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				console.log('[SPONSORS] fetch params:', params)
				const response = await sponsorsList(params)
				console.log('[SPONSORS] API response:', response)
				const { data } = response
				console.log('[SPONSORS] data to commit:', data)
				commit('SPONSORS_STATUS', 'init')
				commit('SPONSORS_LIST', data)
				return data
			} catch (error) {
				console.error('[SPONSORS] fetch error:', error?.response?.status, error?.response?.data || error.message)
				commit('SPONSORS_STATUS', 'init')
				throw error
			}
		},
		async fetchSponsorByID({ commit }, params) {
			commit('SPONSORS_STATUS', 'pending')
			try {
				const { data } = await sponsorByID(params)
				commit('SPONSORS_STATUS', 'init')
				commit('SET_SPONSOR', data.data)
				return data
			} catch (error) {
				commit('SPONSORS_STATUS', 'init')

				return error
			}
		},
		async saveNewSponsor({ commit }, params) {
			commit('SPONSOR_SAVE_STATUS', 'pending')
			try {
				const { data } = await sponsorCreate(params)
				commit('SPONSOR_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SPONSOR_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateSponsor({ commit }, params) {
			commit('SPONSOR_SAVE_STATUS', 'pending')
			try {
				const { data } = await sponsorUpdate(params)
				commit('SPONSOR_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SPONSOR_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteSponsorByID({ commit }, params) {
			commit('SPONSOR_DELETE_STATUS', 'pending')
			try {
				const { data } = await sponsorDestroy(params)
				commit('SPONSOR_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SPONSOR_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
